import styled from 'styled-components/native';
import theme from '../../global/styles/theme';

interface TextDefaultProps {
  color?: string;
  fontSize?: number;
  textAlign?: 'auto' | 'left' | 'right' | 'center' | 'justify';
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  marginTop?: number;
  fontFamily?: string;
  textDecoration?: string;
  appTheme: 'light' | 'dark';
}

const Text = styled.Text<TextDefaultProps>`
  color: ${({color, appTheme}) =>
    color || theme.colors(appTheme).gray[700]};
  font-family: ${({fontFamily}) =>
    fontFamily || theme.fonts.family.opensans.regular};
  font-size: ${({fontSize}: any) =>
    fontSize ? theme.fonts.size[fontSize] : theme.fonts.size[12]};
  margin-bottom: ${({marginBottom}) =>
    marginBottom ? `${marginBottom}px` : '0px'};
  margin-left: ${({marginLeft}) => (marginLeft ? `${marginLeft}px` : '0px')};
  margin-right: ${({marginRight}) =>
    marginRight ? `${marginRight}px` : '0px'};
  margin-top: ${({marginTop}) => (marginTop ? `${marginTop}px` : '0px')};
  text-align: ${({textAlign}) => textAlign || 'auto'};
  text-decoration: ${({textDecoration}) => textDecoration || 'none'};
  text-decoration-color: ${({color, textDecoration, appTheme}) =>
    textDecoration ? color || theme.colors(appTheme).gray[700] : 'transparent'};
  padding: 0px;
`;

export default Text;
